import axios from "axios";
import { jobRequestUrl } from "../../utils";

export const fetchJobRequest = async (jobRequestId: string) => {
  return await axios.get(jobRequestUrl(jobRequestId));
};
